import {
	LastTransactions,
	LastTransactionsAdapter,
} from '@interfaces/FW/transactions/LastTransactions';

export const lastTransactionsAdapter = (data: LastTransactionsAdapter[]): LastTransactions[] =>
	data.map((item) => ({
		fullTank: item.ПовнийБак,
		gasStation: item.АЗС,
		nomenclatureSalesName: item.НоменклатураПродажиНаименование,
		fuelCardCode: item.ТопливнаяКартаКод,
		checkNumber: item.НомерЧека,
		amount: item.Сумма,
		price: item.Цена,
		quantity: item.Количество,
		walletName: item.СчетНаименование,
		gasStationTranslationName: item.АЗСПереводНаименование,
		gasStationTranslationAddress: item.АЗСПереводАдрес,
		gasStationName: item.АЗСНаименование,
		currencyReduction: item.ВалютаСокращение,
		nomenclatureSales: item.НоменклатураПродажи,
		nomenclatureUnit: item.ЕдиницаИзмерения,
		fuelCard: item.ТопливнаяКарта,
		checkDate: item.ДатаЧека,
		methodObtainingCard: item.СпособПолученияКарты,
		walletGUID: item.Счет,
		registrar: item.Регистратор,
		period: item.Период,
	}));
